import Choices from "choices.js";

export class ChoicesFactory {
    static create(el, options = {}) {
        return new Choices(el, {
            noResultsText: "Ничего не найдено",
            itemSelectText: "",
            allowHTML: true,
            ...options,
        });
    }
}
